"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "novara": {
    "6bcab1e2": [{
      "hkey": "7a699705",
      "slug": "bicocca",
      "name": "Bicocca",
      "primary": true,
      "skipSearch": false
    }],
    "bicocca-s-rita": [{
      "hkey": "7a699705",
      "slug": "bicocca",
      "name": "Bicocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c626320e": [{
      "hkey": "5fae401e",
      "slug": "porta-mortara",
      "name": "Porta Mortara",
      "primary": true,
      "skipSearch": false
    }],
    "p-mortara-s-paolo": [{
      "hkey": "5fae401e",
      "slug": "porta-mortara",
      "name": "Porta Mortara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65bef1c6": [{
      "hkey": "da458163",
      "slug": "novara",
      "name": "Novara",
      "primary": true,
      "skipSearch": false
    }],
    "periferia-e-frazioni": [{
      "hkey": "da458163",
      "slug": "novara",
      "name": "Novara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd2caf42": [{
      "hkey": "033c96df",
      "slug": "sacro-cuore",
      "name": "Sacro Cuore",
      "primary": true,
      "skipSearch": false
    }],
    "s-cuore-s-martino": [{
      "hkey": "033c96df",
      "slug": "sacro-cuore",
      "name": "Sacro Cuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eab76070": [{
      "hkey": "a8d0d23f",
      "slug": "sant-agabio",
      "name": "Sant'Agabio",
      "primary": true,
      "skipSearch": false
    }],
    "s-agabio-s-rocco": [{
      "hkey": "a8d0d23f",
      "slug": "sant-agabio",
      "name": "Sant'Agabio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ce77c9f7": [{
      "hkey": "f845d701",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "s-antonio-s-andrea": [{
      "hkey": "f845d701",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;